import { X } from "lucide-react";

export const AromaCubanaPopup = ({ onClose }) => {
  const whatsappUrl =
    "https://wa.me/32469435891?text=Hallo%20👋%20Ik%20heb%20een%20vraag%20voor%20Aroma%20Cubana";

  const orderUrl =
    "https://www.foodbooking.com/api/fb/_jk7rv"; 

  const reservationUrl =
    "https://www.foodbooking.com/api/res/_jk7rv"; 

  const takeawayUrl =
    "https://www.takeaway.com/be/menu/aroma-cubana-sint-niklaas";   

  const mapsUrl =
    "https://www.google.com/maps?q=Aroma+Cubana";

  return (
    <>
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-black/40 z-40"
        onClick={onClose}
      />

      {/* Popup */}
      <div className="fixed bottom-28 left-8 w-80 bg-white rounded-2xl shadow-2xl z-50 overflow-hidden">

        {/* Header */}
        <div className="bg-green-600 text-white p-4 flex justify-between items-center">
          <div>
            <p className="font-semibold">☕ Aroma Cubana</p>
            <p className="text-xs opacity-90">
              Bestellen • Reserveren • Info
            </p>
          </div>
          <button onClick={onClose} aria-label="Sluit popup">
            <X size={18} />
          </button>
        </div>

        {/* Body */}
        <div className="p-4 space-y-3 text-sm bg-gray-50">

          {/* Intro */}
          <div className="bg-white rounded-lg p-3 shadow w-fit max-w-[90%]">
            Waarmee kunnen we je helpen? 👇
          </div>

          {/* Actieknoppen */}
          <div className="space-y-2">

            {/* GloriaFood bestellen */}
            <a
              href={orderUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="block bg-green-500 text-white text-center rounded-lg py-2 font-medium hover:bg-green-600 transition"
            >
              🍽️ Online bestellen
            </a>

            {/* Takeaway */}
            <a
            href={takeawayUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 bg-white border border-gray-300 rounded-lg py-2 px-3 hover:bg-gray-100 transition"
            >
            <img
                src="assets/takeaway.png"
                alt="Takeaway"
                className="h-4 w-auto"
            />
            <span>Bestellen via Takeaway</span>
            </a>

            {/* Reserveren */}
            <a
              href={reservationUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="block bg-white border border-gray-300 rounded-lg py-2 px-3 hover:bg-gray-100 transition"
            >
              📅 Reserveren
            </a>

            {/* Locatie */}
            <a
              href={mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="block bg-white border border-gray-300 rounded-lg py-2 px-3 hover:bg-gray-100 transition"
            >
              📍 Locatie
            </a>

            {/* Contactpagina */}
            <a
              href="/contact"
              className="block bg-white border border-gray-300 rounded-lg py-2 px-3 hover:bg-gray-100 transition"
            >
              ☎️ Contact
            </a>

            {/* Menu */}
            <a
            href="/menu"
            className="block bg-white border border-gray-300 rounded-lg py-2 px-3 hover:bg-gray-100 transition"
            >
            📖 Menu bekijken
            </a>

            {/* WhatsApp */}
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="block bg-green-600 text-white text-center rounded-lg py-2 font-medium hover:bg-green-700 transition"
            >
              💬 Chat via WhatsApp
            </a>

          </div>
        </div>
      </div>
    </>
  );
};